import { render } from "./LoginDialogComponent.vue?vue&type=template&id=86d13b4a"
import script from "./LoginDialogComponent.vue?vue&type=script&lang=js"
export * from "./LoginDialogComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__